export const mapScheduleKpis = (raw) => {
  if (!raw) return [];
    const formatDate = (iso) => {
if (!iso) return "-";
    const d = new Date(iso);
    return d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }); // 21 Nov 2024
  };

  return [
    { label: "Baseline Start Date", value: formatDate(raw.projectStartDate), bg: "#FFF4DE",iconBg: "#FF947A" },
    { label: "Baseline Finish Date", value: formatDate(raw.projectEndDate), bg: "#FFF4DE",iconBg: "#FF947A" },
    { label: "Anticipated End Date", value: formatDate(raw.projectProjectedEndDate), bg: "#FFE2E5",iconBg: "#FF4F8B"},
    { label: "Days to Complete",subText:"From Baseline (R0)", value: raw.remainingDays, bg: "#E8F5E9" },
    { type: "days",label: "Schedule Variance",value: `${raw.scheduleVariance ?? 0} days` , bg: "#DCFCE7", iconBg:"#3CD856"},
    { key: "project-progress",label: "Project Progress", actual: raw.actualProgress, plan: raw.planProgress,bg: "#FFE2E5",iconBg: "#FF4F8B",type: "progress"},
    // { type:"percentage", label: "Critical Activities Variance", value: raw.criticalActivityVariance || 0, bg: "#F3E5F5" },
  ];
};

export const mapActivitiesKpis = (raw) => {
  if (!raw) return [];
    const formatDate = (iso) => {
if (!iso) return "-";
    const d = new Date(iso);
    return d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }); // 21 Nov 2024
  };

  return [
    { label: "Critial Activities", value: raw.criticalActivitiesCount, bg: "#FFF4DE",iconBg: "#FF947A", hasArrow: true },
    { label: "Previous Week Rate", value: `${raw.prevWeeklyRunRate} %`, bg: "#E8F5E9" },
    { label: "Upcoming Critical Activities", subLabel:"next 30 days", value: raw.upcomingCriticalActivitiesCount, bg: "#FFF4DE",iconBg: "#FF947A", hasArrow: true },
    { label: "Projected Monthly Rate", value: `${raw.projectedMonthlyRate} %` , bg: "#DCFCE7", iconBg:"#3CD856"},
    { label: "Upcoming Critical Activities", subLabel:"next 7 days", value: raw.weeklyCriticalActivitiesCount, bg: "#DCFCE7", iconBg:"#3CD856", hasArrow: true},
    { label: "Required Monthly Rate", value: `${raw.reqMonthlyRunRate} %`,bg: "#FFE2E5",iconBg: "#FF4F8B",type: "progress"},
  ];
};